import { UserSettingsScope } from '../../../common/enums/user-settings-scope';

export enum AuthStorageKey {
  COMPANY_ID = 'companyId',
}

export const AUTH_SENSITIVE_KEYS = [
  ...Object.values(UserSettingsScope),
] as const;
